<app-form-manager
    formPlugin="back-button-form"
    [params]="formParams"
    (canceled)="backToList($event)">
</app-form-manager>
